export enum ExpressionCondition {
  HIDE = 'hide',
  DISABLED = 'disabled',
  COMPUTE = 'compute',
  CONDITIONAL_STYLING = 'conditional styling',
  UI_EVENT_EXPRESSION = 'ui event expression',
  TRIGGER_CONDITION = 'trigger condition',
  PROTOTYPE_SELECTION = 'prototype selection',
}
export type PreviewMode = 'none' | 'simple' | 'side-by-side' | 'center-aligned'
